import React, { useMemo } from 'react';
import { Selectbox } from '../FormComponent';
import { convertIdsToDisplay, replaceFileRefsWithNames } from '../../utils/automation/variableUtils';

/**
 * Selectbox that resolves variable refs (${_id:...}) and file refs (@[id]) to display format.
 * Pass raw options (value/label); labels are transformed for display using variables and fileSuggestions.
 */
const SmartSelectbox = ({
    options = [],
    suggestions = [],
    descriptions = {},
    fileSuggestions = [],
    ...selectProps
}) => {
    const displayOptions = useMemo(() => {
        return options.map((opt) => {
            const rawLabel = opt.label ?? opt.value ?? '';
            const withVariables = convertIdsToDisplay(rawLabel, suggestions, descriptions);
            const displayLabel = replaceFileRefsWithNames(withVariables, fileSuggestions);
            return { ...opt, label: displayLabel };
        });
    }, [options, suggestions, descriptions, fileSuggestions]);

    return <Selectbox options={displayOptions} {...selectProps} />;
};

export default SmartSelectbox;
